import React, {useEffect} from 'react';
import {ActionModal, useErrorHandler, ErrorModal} from '../../../../shared';
import {Text} from '@gravity-ui/uikit';
import {useUpdateConsentDocument} from '../../../../entities';
import {useNavigate} from 'react-router';

interface ArchiveConsentDocumentModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  documentId: string;
}

export const ArchiveConsentDocumentModal = ({open, setOpen, documentId}: ArchiveConsentDocumentModalProps) => {
  const navigate = useNavigate();
  const {archiveDocumentMutation} = useUpdateConsentDocument(documentId);

  const {isErrorModalOpen, errorInfo, handleError, handleClose} = useErrorHandler({
    resourceName: 'Архивирование документа',
    title: 'Ошибка при архивировании документа',
  });

  useEffect(() => {
    if (archiveDocumentMutation.error) {
      handleError(archiveDocumentMutation.error as unknown as ApiError);
    }
  }, [archiveDocumentMutation.error, handleError]);

  const handleSubmit = () => {
    archiveDocumentMutation.mutate(documentId, {
      onSuccess: () => {
        setOpen(false);
        navigate('/administration/consents-documents');
      },
    });
  };

  return (
    <>
      <ActionModal
        open={open}
        onClose={() => setOpen(false)}
        setOpen={() => setOpen(false)}
        submitForm={handleSubmit}
        isLoading={archiveDocumentMutation.isPending}
        size={'s'}
        buttonsSize={'l'}
        caption={'Архивирование документа'}
        textButtonApply={'Заархивировать'}
        textButtonCancel={'Отменить'}
        viewActionButton="outlined-danger">
        <Text variant="body-2" color="secondary">
          Вы уверены, что хотите заархивировать этот документ? Обратите внимание, что это действие безвозвратное
        </Text>
      </ActionModal>
      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </>
  );
};
